import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import SideItem from './SideItem';
import Separator from './Separador';
import FontAwesome  from "react-fontawesome"
import loading from '../../../assets/images/dots-loading.gif';
import {
  ListGroup,
  ListGroupItem
} from 'reactstrap';
import {Link} from "react-router-dom";
import _ from 'lodash';

@inject("store") @inject("routes") @observer
export default class SideBar extends Component {

    constructor(props) {
        super(props);
        this.store = this.props.store;
        this.routes = this.props.routes;
        this.loginStore = this.props.store.loginStore;
    }

    render() {
        const sideItens = [];
        
        for (let i=0; i < this.routes.length; i++) {
            const menuCategory = this.routes[i];
            const sideItensGroup = [];
                
           let key = 0;
           if(typeof menuCategory.itens !== 'undefined'){
                for (let j=0; j < menuCategory.itens.length; j++) {
                    const menuCategoryItem = menuCategory.itens[j];
                    if(menuCategoryItem.onSideBar && this.loginStore.checkPermission(menuCategoryItem.permission)){
                        const space = <span className="space"/>
                        const listCount = menuCategoryItem.listCount ? <span className={this.store.appStore.sidebarFechado ? "inbox-count minimized" : "inbox-count"}>{menuCategoryItem.listCount}</span> : "";
                        const item = <SideItem title={menuCategoryItem.label} key={key} to={menuCategoryItem.path}>{space}{listCount}<span className={this.store.appStore.sidebarFechado ? "sidebar-label hidden" : "sidebar-label"}>{menuCategoryItem.label}</span></SideItem>
                        sideItensGroup.push(item);
                        key++;
                    }
                }
            }
            
            const labelIcon = menuCategory.icon ? <FontAwesome className="sidebar-icon" flip={menuCategory.flip ? sideItensGroup.flip : null} name={menuCategory.icon} /> : "";
            const separator = <Separator label={menuCategory.label} labelIcon={labelIcon} sideItensGroup={sideItensGroup} />;
            if(this.loginStore.checkPermission(menuCategory.permission)) {
                sideItens.push(
                    <div key={i} className="menu-category">
                        {separator}
                        <div
                            className={menuCategory.label === this.store.appStore.expandirGrupoSidebar ? "item-group" : "item-group collapsed"}>
                            {sideItensGroup}
                        </div>
                    </div>);
            }
        }

        return (
            <div className={this.store.appStore.sidebarFechado ? "side-bar minimized" : "side-bar"}>
                {(!this.loginStore.usuarioLogado || !this.loginStore.usuarioLogado.matricula) && this.loginStore.loadingUsuarioLogado &&
                <div className="sidebar-loader">
                    <img src={loading} alt="loading" className="loading"/>
                </div>
                }
                {(this.loginStore.checkPermission("solicitar-mot") || this.loginStore.checkPermission("administrador")) &&
                <div className="sidebar-new-button-container">
                    <Link to="/nova-solicitacao-contratacao" className="btn btn-primary sidebar-new-button"
                          title="Nova solicitação">
                        <FontAwesome className="sidebar-icon" name="plus"/>
                        <span className={this.store.appStore.sidebarFechado ? "sidebar-label hidden" : ""}>Nova solicitação</span>
                    </Link>
                </div>
                }
                <ListGroup >
                    {sideItens}
                </ListGroup>
            </div>
        )
    }
}